import { useEffect } from 'react';
import { getFullUrl } from 'hubspot-url-utils';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { getIsLocalDevelopment } from 'marketplace-ui-common/utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
export function InstallSuccess() {
  const isLocalDevelopment = getIsLocalDevelopment();
  useEffect(() => {
    const targetOrigin = getFullUrl(isLocalDevelopment ? 'local' : 'app');
    const message = {
      type: 'INSTALL_SUCCESS'
    };
    if (window.opener) {
      // Popup context - post message to the opener window
      window.opener.postMessage(message, targetOrigin);
    } else if (window.parent && window.parent !== window) {
      // Iframe context - post message to the parent window
      window.parent.postMessage(message, targetOrigin);
    }
  }, [isLocalDevelopment]);
  return /*#__PURE__*/_jsx(LoadingSpinner, {});
}